export const useNewsPagination = () => {
  const { isDesktop } = useResponsive()

  const countNews = ref(0)
  const currentPage = ref(1)
  const countElementsOnPage = !isDesktop.value ? 6 : 12

  const countPages = computed(() => {
    return Math.ceil(countNews.value / countElementsOnPage)
  })

  const scrollToTop = () => {
    window?.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  const onChangeCurrentPage = async (value: number) => {
    currentPage.value = value

    scrollToTop()
  }

  return {
    countNews,
    currentPage,
    countElementsOnPage,
    countPages,
    onChangeCurrentPage,
  }
}
